import Cookies from 'universal-cookie';

/**
 * Маркер «вернувшегося пользователя» — отличает гостя от того, кто уже авторизовался ранее
 * на этом устройстве. Аналог «доверенного устройства» в нативке (там — наличие refresh-токена
 * + биометрия). Переживает протухание/очистку токенов сессии.
 *
 * Хранится параллельно в localStorage И в cookie: если localStorage недоступен (приватный
 * режим, отключён) — остаётся cookie, и наоборот. Считаем вернувшимся, если есть хоть где-то.
 */
const KEY = 'moni-known-user';
const ONE_YEAR_SEC = 60 * 60 * 24 * 365;

const cookies = new Cookies(null, { path: '/' });

export function markReturningUser(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // localStorage недоступен — полагаемся на cookie
  }
  cookies.set(KEY, '1', { path: '/', maxAge: ONE_YEAR_SEC, sameSite: 'lax' });
}

export function isReturningUser(): boolean {
  try {
    if (localStorage.getItem(KEY)) return true;
  } catch {
    // игнорируем — проверяем cookie ниже
  }
  return Boolean(cookies.get(KEY));
}

export function clearReturningUser(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // игнорируем
  }
  cookies.remove(KEY, { path: '/' });
}
